import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '../../../environments/environment';

export type SubscriptionTier = 'FREE' | 'PRO' | 'ENTERPRISE';
export type SubscriptionStatus = 'ACTIVE' | 'PENDING_SETUP';

export interface SubscribeResponse {
  subscriptionTier: SubscriptionTier;
  subscriptionStatus: SubscriptionStatus;
}

export interface DashboardUser {
  id: string;
  email: string;
  givenName: string;
  familyName: string;
  status: string;
  subscriptionTier: SubscriptionTier;
  subscriptionStatus: SubscriptionStatus;
  createdAt: string;
  updatedAt: string;
}

@Injectable({ providedIn: 'root' })
export class CoreService {
  private readonly base = `${environment.apiUrl}/api/v1`;

  constructor(private readonly http: HttpClient) {}

  subscribe(tier: SubscriptionTier): Observable<SubscribeResponse> {
    return this.http.post<SubscribeResponse>(`${this.base}/subscribe`, { tier });
  }

  getUser(userId: string): Observable<DashboardUser> {
    return this.http.get<DashboardUser>(`${this.base}/users/${userId}`);
  }

  // STUB: PATCH /api/v1/user/email does not exist on the backend yet.
  // When implemented, replace the body with:
  //   return this.http.patch<{ message: string }>(`${this.base}/user/email`, { email });
  updateEmail(email: string): Observable<{ message: string }> {
    console.log('[CoreService] updateEmail stub — email change requested for:', email);
    return of({ message: 'Email update request received. Check your inbox to confirm the change.' });
  }
}
